import BooleanUtils from '../primitives/BooleanUtils';
Boolean.prototype.toNumber = function () {
    return BooleanUtils.toNumber(this);
};
Boolean.prototype.toNumberString = function () {
    return BooleanUtils.toNumberString(this);
};
Boolean.fromNumber = BooleanUtils.fromNumber;
Boolean.isBoolean = BooleanUtils.isBoolean;
Boolean.parse = BooleanUtils.parse;
Boolean.tryParse = BooleanUtils.tryParse;
//# sourceMappingURL=BooleanExtensions.js.map